import React from 'react'

export const withLazyRef =
  WrappedComponent =>
  ({ lazyRef, ...rest }) =>
    <WrappedComponent ref={lazyRef} {...rest} />
